import { render, staticRenderFns } from "./itable.vue?vue&type=template&id=29cdee29"
import script from "./itable.vue?vue&type=script&lang=js"
export * from "./itable.vue?vue&type=script&lang=js"
import style0 from "./itable.vue?vue&type=style&index=0&id=29cdee29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports